module.exports = __webpack_public_path__ + "static/media/10.90b672cc.jpg";